import { getControllerProps } from '../controllerProps/controllerProps';

export const getControllerPromiseError = (id: string) => {
  const state = getControllerProps()?.__promise?.[id];
  if (state?.status === 'rejected') {
    return state?.error;
  }
};
